/**
 * Возвращает наименьшую степень двойки, не меньшую n.
 * nextPowerOfTwo(5) = 8, nextPowerOfTwo(8) = 8, nextPowerOfTwo(33) = 64.
 */
export function nextPowerOfTwo(n: number): number {
  if (n <= 1) return 1;
  return 2 ** Math.ceil(Math.log2(n));
}

/**
 * Возвращает массив длины `size` (степень двойки) — номера посевов в порядке слотов.
 * Стандартная расстановка посевов в сетке: при удвоении размера каждая позиция
 * из сетки вдвое меньшего размера расширяется в пару (X, size+1-X). Ориентация
 * пары чередуется, чтобы сильнейшие были максимально разнесены по сетке.
 *
 * size = 1 → [1]
 * size = 2 → [1, 2]
 * size = 4 → [1, 4, 3, 2]
 * size = 8 → [1, 8, 5, 4, 3, 6, 7, 2]
 */
export function generateSeedOrder(size: number): number[] {
  if (size < 1 || (size & (size - 1)) !== 0) {
    throw new Error(`size must be a power of two, got ${size}`);
  }
  if (size === 1) return [1];
  if (size === 2) return [1, 2];

  const half = generateSeedOrder(size / 2);
  const order: number[] = [];
  half.forEach((x, i) => {
    const mirror = size + 1 - x;
    if (i % 2 === 0) {
      order.push(x, mirror);
    } else {
      order.push(mirror, x);
    }
  });
  return order;
}
